var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 164,
    viewBox: "0 0 197 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.7455 10.0952C61.7455 10.0952 28.2356 25.0581 11.5227 48.1148C-5.19016 71.1716 -3.86781 100.834 16.4406 122.852C36.7491 144.869 75.566 141.978 108.067 155.925C140.569 169.872 176.427 167 191.796 137.45C207.164 107.9 183.99 96.8565 180.009 62.659C176.029 28.4616 140.856 -21.6136 61.7455 10.0952Z",
    fill: "#DEC3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.bd112f0ac6c8d7c8530d5fc23f2a8ff3.svg";
export { ForwardRef as ReactComponent };